import { supabase } from '../config/supabase'

/**
 * Fetch cancellation policy (single global row).
 * Returns policy object with fee and cutoff settings.
 */
export const getCancellationPolicy = async () => {
  try {
    const { getSelectedSalonId } = await import('../utils/salonScope')
    const salonId = getSelectedSalonId()
    let query = supabase
      .from('cancellation_policies')
      .select('fee_policy_enabled, fee_window_hours, fee_percentage, cutoff_policy_enabled, cutoff_hours_before')
    if (salonId) {
      query = query.eq('salon_id', salonId)
    }
    const { data, error } = await query.limit(1).maybeSingle()

    if (error) {
      // If no policy exists, return null (not an error)
      if (error.code === 'PGRST116') {
        console.log('ℹ️ No cancellation policy found for salon')
        return null
      }
      console.error('❌ Error fetching cancellation policy:', error)
      return null
    }

    if (!data) return null

    return {
      feePolicyEnabled: !!data.fee_policy_enabled,
      feeWindowHours:
        typeof data.fee_window_hours === 'number' ? data.fee_window_hours : null,
      feePercentage:
        data.fee_percentage != null ? Number(data.fee_percentage) : null,
      cutoffPolicyEnabled: !!data.cutoff_policy_enabled,
      cutoffHoursBefore:
        typeof data.cutoff_hours_before === 'number'
          ? data.cutoff_hours_before
          : null,
    }
  } catch (error) {
    console.error('❌ Exception in getCancellationPolicy:', error)
    return null
  }
}
